import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import navLinks, { getRouteTitle } from "../../utils/navigation";
import MaterialIcons from "../MaterialIcons";
import "./header.scss";

const Header = () => {
	const location = useLocation();
	const [openNav, setOpenNav] = useState(false);
	useEffect(() => {
		setOpenNav(false);
	}, [location.pathname]);
	useEffect(() => {
		document.addEventListener("keydown", (e) => {
			if (e.key === "Escape") setOpenNav(false);
		});
		return () => {
			document.removeEventListener("keydown", (e) => {
				if (e.key === "Escape") setOpenNav(false);
			});
		};
	}, []);

	return (
		<header className="header">
			<div
				className="header-current"
				onClick={() => setOpenNav((p) => !p)}
			>
				<span className="header-current-route">
					{getRouteTitle(location.pathname)}
				</span>
				<MaterialIcons>unfold_more</MaterialIcons>
			</div>
			<div
				className={`header-routes-list ${
					openNav && "header-routes-list-active"
				}`}
			>
				{navLinks.map(({ icon, route, text }, index) => (
					<Link key={index} to={route} className="header-route">
						{icon}
						{text}
					</Link>
				))}
			</div>
		</header>
	);
};

export default Header;
